import React, { useEffect, useState } from 'react'

import { Modal, notification } from 'antd';

import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { NuInput } from '../../../../Components/Utils/Input';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import axiosInstance from '../../../../Services/axiosCommon';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import { useToast } from '../../../../Components/Others/ToastServices';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';


const CreateEquipments = ({open, getData, onCancel, data,projectList,firstProject }) => {
    const { value: brand,getData:refbrand } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "brand_equipments"
      );
      const { value: unit,getData:refunit } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "unit_equipments"
      );
          
      const [api, contextHolder] = notification.useNotification();
    const [createNew, setCreateNew] = useState({
        brand:"", model:"", name:"",unit:""
    });
      const [selectedFile, setSelectedFile] = useState(null);
      const [image, setImage] = useState([]);
      const toast = useToast();
    
      function handleImageChange(e) {
        const maxFileSize = 200000000; // 200 MB
        const files = Array.from(e.target.files);
        let fileArr = [];
        files.map((item) => {
          if (item.size < maxFileSize) {
            fileArr.push(item);
          } else {
            toast.open({
              type: "warning",
              message: `File Size to big`,
              description: `${item.name} is Removed and not Uploaded`,
              // placement: "bottomRight",
            });
          }
        });
        let tempArr = [];
        setSelectedFile(fileArr);
        files.map((item) => {
          if (item.size < maxFileSize) {
            let fileName = item?.name;
            console.log("fname", fileName);
            // let fileExtention = fileName.split(".").reverse()[0];
            // if (filetype?.includes(fileExtention)) {
            tempArr.push(fileName);
            // } else {
            //   let x = URL.createObjectURL(item);
            //   tempArr.push(x);
            // }
          }
        });
        console.log(tempArr, "temp");
        setImage(tempArr);
      }
    
      const removeImages = (value) => {
        console.log("value", value);
        let List = selectedFile.filter((item) => item?.name !== value);
        console.log("LIst", List);
        setSelectedFile([...List]);
        let tempArr = [];
        List.map((item) => {
          let fileName = item?.name;
          // console.log('fname',fileName);
          // let fileExtention =  fileName.split(".").reverse()[0]
          // if(filetype?.includes(fileExtention)){
          tempArr.push(fileName);
          // }else{
          //   let x = URL.createObjectURL(item)
          //   tempArr.push(x)
          // }
        });
        setImage(tempArr);
      };

      
    useEffect(() => {
      data&&setCreateNew({
        brand:data.brand,
        model:data.model,
        name:data.name,
        unit:data.unit,


      })
    },[data])
  const { Oncancel, addFormData, isLoading } = useAddFormData();

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema:yup.object({
        // name:yup.string().required("Name is Requried")
      }),
      onSubmit: (value,{resetForm}) => {
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(value));
   if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("equipmentImage", file);
        });
      } else {
        formData.append("equipmentImage", []);
      }
      // addFormData("/equipments/new-equipment", formData, resetForm);
       
        axiosInstance
          .post("/equipments/new-equipment", formData, resetForm)
          .then((res) => {
            console.log(res);
            if (res.status === 201 || res.data.status == true) {
              getData();
              resetForm();
              api.success({
                message: `Description Creation successfully`,
                description: res?.data?.msg || "Added In The Description",
                placement: "bottomRight",
              });
              onCancel();
            } else {
              api.error({
                message: `Description Creation failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((err) => {
            api.error({
              message: `Description Creation failed`,
              description: err?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
          });
      },
    });
  
   
  
    return (
      <>
      {contextHolder}
       <Modal
        open={open}
        title={data ? "Edit Equipment" : "Create Equipments"}
        width="50%"
        className="perfect-centered-modal"
        centered
        onCancel={onCancel}
        footer={null}
        styles={{
          body: {
            maxHeight: '70vh',
            overflowY: 'auto',
            padding: '4px'
          }
        }}
      >
      <form onSubmit={formik.handleSubmit} >
       <div className=" w-full flex flex-wrap">
               
             
               <NuInput
                label="Name"
                placeholder="Name"
                formik={formik}
                name="name"
                width="w-full"
                new_width="w-full"
  
              />
              <DropDownAddMetaData
                            label="Unit"
                            placeholder="Choose"
                            Options={unit}
                            // Options={dummyunits}

                            formik={formik}
                            name="unit"
                            width="w-full "
                            getFunc={refunit}
                            displayProperty={"unit"}
                            propertyName={"unit_equipments"}
                            FixPosition={false}
                            PortalTarget={false}
                isRequired={true}
  
                          />
                          <DropDownAddMetaData
                            label="Brand"
                            placeholder="Choose"
                            Options={brand}
                            // Options={dummyBrands}

                            formik={formik}
                            name="brand"
                            width="w-full "
                            getFunc={refbrand}
                            displayProperty={"brand"}
                            propertyName={"brand_equipments"}
                            FixPosition={false}
                            PortalTarget={false}
                isRequired={true}
  
                          />
               <NuInput
                label="Model no"
                placeholder="Model no"
                formik={formik}
                name="model"
                width="w-full"
                new_width="w-full"
  
              />

<div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
             
  <button
                type="submit"
               
                className="w-11/12 bg-textColor-main py-3 rounded-lg cursor-pointer text-sm outline-none border-none hover:text-white focus:text-white text-white  mx-auto"
              >
                Create 
              </button>
            </div>
       
      </form>
      </Modal>
      </>
    );
  };
  
  

export default CreateEquipments